export const Constants = {
    JPY: {
        id: 1,
        code: "JPY",
        name: "円",
    },

    USD: {
        id: 2,
        code: "USD",
        name: "$",
    },

    JpyToOther: {
        type: 1,
        name: "JPY To Other",
    },

    OtherToJpy: {
        type: 2,
        name: "Other to JPY",
    },

    OtherToOther: {
        type: 3,
        name: "Other to Other",
    },

    VoucherExchangeType: {
        JpyToOther: {
            id: 1,
            name: "円→外貨",
        },
        OtherToJpy: {
            id: 2,
            name: "外貨→円",
        },
        OtherToOther: {
            id: 3,
            name: "外貨→外貨",
        },
    },

    VoucherType: {
        invoice_bill: {
            id: 1,
            templateId: 10,
            name: "領収証",
            groupTypeId: 1,
            groupTypeName: "",
            ocr: true,
            iconIncome: "入金",
            iconExpenditure: "支出",
        },
        invoice_invoice: {
            id: 2,
            templateId: 3,
            name: "請求書",
            groupTypeId: 1,
            groupTypeName: "",
            ocr: true,
            icon: "請求書",
        },
        invoice_bill_other: {
            id: 4,
            templateId: 4,
            name: "その他",
            groupTypeId: 1,
            groupTypeName: "",
            ocr: false,
            icon: "その他",
        },
        contract_travel: {
            id: 5,
            templateId: 5,
            name: "旅行申込書",
            groupTypeId: 6,
            groupTypeName: "",
            ocr: true,
            icon: "申込書",
        },
        contract_underwriting: {
            id: 6,
            templateId: 5,
            name: "旅行引受書",
            groupTypeId: 6,
            groupTypeName: "",
            ocr: true,
            icon: "引受書",
        },
        contract_outsourcing: {
            id: 7,
            templateId: 6,
            name: "業務委託契約書",
            groupTypeId: 2,
            groupTypeName: "",
            ocr: true,
            icon: "業務委託",
        },
        contract_other: {
            id: 8,
            templateId: 4,
            name: "その他",
            groupTypeId: 2,
            groupTypeName: "",
            ocr: false,
            icon: "その他",
        },
        local_expense_voucher_carry_cash: {
            id: 9,
            templateId: 7,
            name: "携行現金収支明細",
            groupTypeId: 3,
            groupTypeName: "",
            ocr: false,
            icon: "収支明細",
        },
        local_expense_voucher_receipt: {
            id: 11,
            templateId: 9,
            name: "領収証",
            groupTypeId: 3,
            groupTypeName: "",
            ocr: true,
            iconIncome: "入金",
            iconExpenditure: "支出",
            iconDiamondStamp: "DS",
        },
        currency_exchange_receipt: {
            id: 12,
            templateId: 8,
            name: "両替レシート",
            groupTypeId: 3,
            groupTypeName: "",
            ocr: false,
            icon: "両",
        },
        local_expense_voucher_other: {
            id: 13,
            templateId: 4,
            name: "その他",
            groupTypeId: 3,
            groupTypeName: "",
            ocr: false,
            icon: "その他",
        },
        certificate_Registration_other: {
            id: 14,
            templateId: 4,
            name: "その他",
            groupTypeId: 4,
            groupTypeName: "",
            ocr: false,
            icon: "その他",
        },
        receipt_carry_cash: {
            id: 15,
            templateId: 1,
            name: "領収証(携行現金/Bizプリカ)",
            groupTypeId: 5,
            groupTypeName: "",
            ocr: true,
            iconIncome: "入金",
            iconExpenditure: "支出",
        },
        carry_cash_other: {
            id: 16,
            templateId: 4,
            name: "その他",
            groupTypeId: 5,
            groupTypeName: "",
            ocr: false,
            icon: "その他",
        },
        no_voucher: {
            id: 17,
            templateId: 1,
            name: "証票なし",
            groupTypeId: 5,
            groupTypeName: "",
            ocr: false,
            iconIncome: "入金",
            iconExpenditure: "支出",
        },
        receipt_local_placement_income: {
            id: 18,
            templateId: 2,
            name: "領収証(現地斡旋収入)",
            groupTypeId: 5,
            groupTypeName: "",
            ocr: true,
            iconIncome: "入金",
            iconExpenditure: "支出",
            iconDiamondStamp: "DS",
        },
        local_placement_income_other: {
            id: 20,
            templateId: 4,
            name: "その他",
            groupTypeId: 5,
            groupTypeName: "",
            ocr: false,
            icon: "その他",
        },
        currency_exchange_receipt_cash: {
            id: 21,
            templateId: 8,
            name: "両替レシート (cash)",
            groupTypeId: 5,
            groupTypeName: "",
            ocr: false,
            icon: "両",
        },
        local_placement_income_other_no_voucher: {
            id: 22,
            templateId: 2,
            name: "証票なし(現地斡旋収入)",
            groupTypeId: 5,
            groupTypeName: "",
            ocr: false,
            iconIncome: "入金",
            iconExpenditure: "支出",
            iconDiamondStamp: "DS",
        },
        before_conditions: {
            id: 23,
            templateId: 5,
            name: "旅行条件書(契約書類)",
            groupTypeId: 6,
            groupTypeName: "",
            ocr: true,
        },
        before_schedule: {
            id: 24,
            templateId: 5,
            name: "旅行日程表(契約書類)",
            groupTypeId: 6,
            groupTypeName: "",
            ocr: false,
        },
        before_items: {
            id: 25,
            templateId: 5,
            name: "旅行内訳書(契約書類)",
            groupTypeId: 6,
            groupTypeName: "",
            ocr: false,
        },
        before_pamphlet: {
            id: 26,
            templateId: 5,
            name: "旅行パンフレット(契約書類)",
            groupTypeId: 6,
            groupTypeName: "",
            ocr: false,
        },
        before_bulk: {
            id: 27,
            templateId: 5,
            name: "条件書内訳書日程表一括(契約書類)",
            groupTypeId: 6,
            groupTypeName: "",
            ocr: false,
        },
        after_conditions: {
            id: 28,
            templateId: 5,
            name: "旅行条件書(変更書類)",
            groupTypeId: 6,
            groupTypeName: "",
            ocr: true,
        },
        after_schedule: {
            id: 29,
            templateId: 5,
            name: "旅行日程表(変更書類)",
            groupTypeId: 6,
            groupTypeName: "",
            ocr: false,
        },
        after_items: {
            id: 30,
            templateId: 5,
            name: "旅行内訳書(変更書類)",
            groupTypeId: 6,
            groupTypeName: "",
            ocr: false,
        },
        after_bulk: {
            id: 31,
            templateId: 5,
            name: "条件書内訳書日程表一括(変更書類)",
            groupTypeId: 6,
            groupTypeName: "",
            ocr: false,
        },
        confirm_conditions: {
            id: 32,
            templateId: 5,
            name: "旅行条件書(確定書類)",
            groupTypeId: 6,
            groupTypeName: "",
            ocr: true,
        },
        confirm_schedule: {
            id: 33,
            templateId: 5,
            name: "旅行日程表(確定書類)",
            groupTypeId: 6,
            groupTypeName: "",
            ocr: false,
        },
        confirm_items: {
            id: 34,
            templateId: 5,
            name: "旅行内訳書(確定書類)",
            groupTypeId: 6,
            groupTypeName: "",
            ocr: false,
        },
        confirm_bulk: {
            id: 35,
            templateId: 5,
            name: "条件書内訳書日程表一括(確定書類)",
            groupTypeId: 6,
            groupTypeName: "",
            ocr: false,
        },
        contract_document: {
            id: 36,
            name: "契約書類",
            groupTypeId: 2,
            groupTypeName: "",
            ocr: true,
        },
        change_contract: {
            id: 37,
            templateId: 6,
            name: "変更契約書",
            groupTypeId: 2,
            groupTypeName: "",
            ocr: true,
            icon: "変更契約",
        },
        use_biz_pre_paid_card_cash: {
          id: 38,
          templateId: 1,
          name: 'Bizプリカ 利用明細書',
          groupTypeId: 5,
          groupTypeName: "",
          ocr: true,
          iconIncome: "Bizﾌﾟﾘｶ",
          iconExpenditure: "Bizﾌﾟﾘｶ",
        },
        partner_contract: {
            id: 39,
            templateId: 6,
            name: "委託先契約書",
            groupTypeId: 2,
            groupTypeName: "",
            ocr: true,
            icon: "委託契約",
        },
        non_travel_contract: {
            id: 40,
            templateId: 4,
            name: "契約書・覚書",
            groupTypeId: 7,
            groupTypeName: "",
            ocr: false,
            icon: "請求書",
        },
        non_travel_invoice_bill: {
            id: 41,
            templateId: 4,
            name: "領収証・請求書",
            groupTypeId: 7,
            groupTypeName: "",
            ocr: false,
            icon: "領収証・請求書",
        },
        non_travel_other: {
            id: 42,
            templateId: 4,
            name: "その他",
            groupTypeId: 7,
            groupTypeName: "",
            ocr: false,
            icon: "その他",
        },
    },

    ExchangeType: [
        {
            id: 1,
            value: "円→外",
        },
        {
            id: 2,
            value: "外→円",
        },
        {
            id: 3,
            value: "外→外",
        },
    ],

    // D-MOS(ツアー情報取得SOQL)から取得するキー名一覧（取得対象のVoucherTypeのみ）
    VoucherBoxFolderNames: [
        {
            // 請求書・領収証（出金伝票・アト発行）-領収証
            voucherTypeId: 1,
            dmosKey: "01Seikyu"
        },
        {
            // 請求書・領収証（出金伝票・アト発行）-請求書
            voucherTypeId: 2,
            dmosKey: "01Seikyu"
        },
        {
            // 請求書・領収証（出金伝票・アト発行）-その他
            voucherTypeId: 4,
            dmosKey: "20Other"
        },
        {
            // 現地経費関連証票-収支明細
            voucherTypeId: 9,
            dmosKey: "10Keikokin"
        },
        {
            // 現地経費関連証票-領収証
            voucherTypeId: 11,
            dmosKey: "10Keikokin"
        },
        {
            // 現地経費関連証票-両替レシート
            voucherTypeId: 12,
            dmosKey: "10Keikokin"
        },
        {
            // 現地経費関連証票-その他
            voucherTypeId: 13,
            dmosKey: "10Keikokin"
        },
    ],

    VoucherTemplate: {
        bill1: {
            id: 1,
            name: '',
        },
        bill2: {
            id: 2,
            name: '',
        },
        receipt: {
            id: 3,
            name: '',
        },
        other: {
            id: 4,
            name: '',
        },
        registration: {
            id: 5,
            name: '',
        },
        contract: {
            id: 6,
            name: '',
        },
        carry_cash: {
            id: 7,
            name: '',
        },
        exchange: {
            id: 8,
            name: '',
        },
        bill3: {
            id: 9,
            name: '',
        },
        bill4: {
            id: 10,
            name: '',
        },
    },

    GroupVoucherType: {
        invoice_bill: {
            id: 1
        },
        contract: {
            id: 2
        },
        local_expense_voucher: {
            id: 3
        },
        other: {
            id: 4
        },
        cash_detail: {
            id: 5
        },
        travel_contract: {
            id: 6
        },
        non_travel: {
            id: 7
        },
    },

    // 年度開始月
    FiscalYearStartMonth: 4,

    VoucherService: {
        Empty: {
            id: "",
            name: "",
        },
        Optional: {
            id: 1,
            name: "オプショナル",
        },
        Agreement: {
            id: 2,
            name: "斡旋収入",
        },
        Gifts: {
            id: 3,
            name: "土産収入",
        },
        Tips: {
            id: 4,
            name: "チップ・心付け",
        },
        DiamondStamp: {
            id: 5,
            name: "ダイヤスタンプ",
        },
    },

    ExternalVoucherService: {
        Empty: {
            id: "",
            name: "",
        },
        Optional: {
            id: 1,
            name: "オプショナル",
        },
        Agreement: {
            id: 2,
            name: "斡旋収入",
        },
        Gifts: {
            id: 3,
            name: "土産収入",
        },
        Tips: {
            id: 4,
            name: "チップ・心付け",
        },
    },

    VoucherServiceLocalPlacement: {
        Optional: {
            id: 1,
            name: "オプショナル",
            icon: "OP",
        },
        Agreement: {
            id: 2,
            name: "斡旋収入",
            icon: "斡旋",
        },
        Gifts: {
            id: 3,
            name: "土産収入",
            icon: "土産",
        },
        DiamondStamp: {
            id: 5,
            name: "ダイヤスタンプ",
            icon: "DS",
        },
    },

    InternalVoucherServiceLocalPlacement: {
        Optional: {
            id: 1,
            name: "オプショナル",
        },
        Agreement: {
            id: 2,
            name: "斡旋収入<br />土産収入",
        },
        DiamondStamp: {
            id: 5,
            name: "ダイヤスタンプ",
        },
    },
    ExternalVoucherServiceLocalPlacement: {
        Optional: {
            id: 1,
            name: "オプショナル",
        },
        Agreement: {
            id: 2,
            name: "斡旋収入",
        },
        DiamondStamp: {
            id: 3,
            name: "土産収入",
        },
    },

    VoucherServiceMinimize: {
        Empty: {
            id: "",
            name: "",
        },
        Tips: {
            id: 4,
            name: "チップ・心付け",
        },
    },

    VoucherInOutType: {
        Out: {
            id: 1,
            name: "支出",
        },
        In: {
            id: 2,
            name: "入金",
        },
    },

    VoucherTaxRate: {
        Eight: {
            id: 1,
            name: "8%",
            icon: "軽"
        },
        Ten: {
            id: 2,
            name: "10%",
        },
        Other: {
            id: 3,
            name: "複数",
            icon: "複"
        },
        Free: {
            id: 4,
            name: "不課税",
            icon: "不"
        },
    },

    TaxExempt: {
        Taxable: {
            id: 0,
            name: "適格請求書発行事業者",
        },
        TaxFree: {
            id: 1,
            name: "免税事業者",
        },
    },

    VoucherTaxRateOther: {
        Eight: {
            id: 1,
            name: "8%",
        },
        Ten: {
            id: 2,
            name: "10%",
        },
        Free: {
            id: 4,
            name: "不課税",
        },
    },

    VoucherSlip: {
        On: {
            id: 1,
            name: "あり",
        },
        Off: {
            id: 0,
            name: "なし",
        },
    },

    CashScreenType: 1,
    LocalIncomeScreenType: 2,
    ExchangeScreenType: 3,
    DiamondType: 3,

    BeforeContractScreenType: 4,
    AfterContractScreenType: 5,
    ConfirmContractScreenType: 6,

    SubContractScreenType: 1,
    ChangeContractScreenType: 2,
    OtherContractScreenType: 3,
    PartnerContractScreenType: 4,

    Upload: {
        maxSize: 100 * 1024 * 1024,
        maxFile: 10,
    },

    ItemPerpage: 50,

    TypeAdminGroup: {
        branch: {
            id: 1,
            name: "個所",
        },
        department: {
            id: 2,
            name: "課",
        },
        group: {
            id: 3,
            name: "グループ",
        },
    },

    TourType: {
        domestic: {
            id: 1,
            name: 'Domestic',
        },
        international: {
            id: 2,
            name: 'International',
        },
    },

    csrfTokenUsed: 46,
    remakePassword: "Stap@2021",
    ocrList: [
        {
            id: 1,
            name: "OCRあり",
        },
        {
            id: 2,
            name: "OCRなし",
        },
    ],

    bizPrePaidCard: [
        {
            id: 1,
            name: "利用あり",
        },
        {
            id: 2,
            name: "利用なし",
        },
    ],
    VoucherWithBizPrePaidCard: {
      use: "Bizプリカ利用分(詳細別紙)",
      use_domestic: "Bizプリカ利用明細書",
      accountName: "Bizプリカ"
    },
    InputT: [
        {
            id: 1,
            name: "自身分",
        },
        {
            id: 2,
            name: "全員分",
        },
    ],
};



// WEBPACK FOOTER //
// ./src/helpers/constants.js